var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFuelet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 342"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "upload-c0805a1f-06b9-428f-b512-5f3b00b2c36d 4",
    width: 32,
    height: 32,
    rx: 4,
    fill: "#1E1E22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427319192"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "upload-c0805a1f-06b9-428f-b512-5f3b00b2c36d 3",
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1E1E22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 28C12.9613 28 10.1887 26.8684 8.0743 25.0063L14.8876 20.1442C15.307 19.8451 15.8839 20.1787 15.8332 20.6917L15.5647 23.4163C15.5092 23.977 16.1875 24.2977 16.5859 23.8993L20.2426 20.2426C22.6372 17.848 22.5847 13.9333 20.0851 11.6053C17.7043 9.388 13.9561 9.5584 11.6557 11.8591L8.1118 15.4027C7.7122 15.8026 8.0365 16.4827 8.5987 16.4239L11.3254 16.1386C11.8393 16.0849 12.1765 16.663 11.8762 17.0839L6.9937 23.9257C5.1316 21.8113 4 19.0387 4 16C4 9.3727 9.3727 4 16 4C22.6273 4 28 9.3727 28 16C28 22.6273 22.6273 28 16 28Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFuelet);
export default __webpack_public_path__ + "static/media/icon-fuelet.0fe511865a4a53d8bbfdc475bfc67e3a.svg";
export { ForwardRef as ReactComponent };